var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLeftTool2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2938 13.3956C18.7302 13.1495 19.2835 13.1495 19.7198 13.3956L36.0638 22.6135C36.8968 23.0834 36.9117 24.1751 36.0917 24.6634L19.7478 34.3957C19.2982 34.6634 18.7155 34.6634 18.2659 34.3957L1.92193 24.6634C1.10197 24.1751 1.11687 23.0834 1.94991 22.6135L18.2938 13.3956Z",
    fill: "#D9F2EF",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.82867 27.1129L24.6424 16.0176M12.2924 30.7635L31.2526 19.8116",
    stroke: "#414862",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2696 27.1129L13.4559 16.0176M26.0645 30.7635L7.35414 19.5769",
    stroke: "#414862",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0485 2.11597C14.8817 2.11597 11.5 5.54134 11.5 9.76121C11.5 11.1778 11.7265 11.9499 12.1039 13.1566C13.2211 16.7469 18.5805 21.5439 19.0485 22.0611C19.5165 21.5439 24.8683 16.7469 25.9855 13.1791C26.3629 11.9648 26.5969 11.1928 26.5969 9.76871C26.5969 5.54883 23.2152 2.12346 19.0485 2.12346V2.11597ZM19.0485 13.1116C16.9651 13.1116 15.2742 11.4327 15.2742 9.36396C15.2742 7.29525 16.9651 5.61629 19.0485 5.61629C21.1319 5.61629 22.8227 7.29525 22.8227 9.36396C22.8227 11.4327 21.1319 13.1116 19.0485 13.1116Z",
    fill: "#70C2EA",
    stroke: "#414862",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLeftTool2);
export default __webpack_public_path__ + "static/media/ico-left-tool-2.6c14234ec659edf4c3120ef24c53d71d.svg";
export { ForwardRef as ReactComponent };